import { DiContainerInjectFn } from '@@/di/ts';
import { BusinessOffersService } from './services/business-offers.service';

export default ((container) => {
    container.bind(BusinessOffersService).to(BusinessOffersService).inSingletonScope();
}) as DiContainerInjectFn;
